import SearchConsoleCard from './SearchConsoleCard'
import SearchConsoleGraph from './SearchConsoleGraph'

import './searchConsolePlaceholder.scss'

export default class SearchConsolePlaceholder extends React.Component {
  state = {
    metric: 'impressions'
  }

  render() {
    const metrics = ['Total Impressions', 'Total Clicks', 'Average CTR', 'Average Position']

    return (
      <div className="search-console-placeholder">
        <div className="search-console-placeholder__card-container">
          {metrics.map((metric, index) => (
            <SearchConsoleCard placeholder compact key={`empty-metric-${index}`} title={metric} />
          ))}
        </div>
        <div className="search-console-placeholder__graph-container medium-spacing--top">
          <SearchConsoleGraph placeholder compact />
        </div>
        <div className="search-console-placeholder__overlay">
          {this.props.children}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/components/search_console/SearchConsolePlaceholder.js